module.exports = __webpack_public_path__ + "img/close-action-sheet.7013bc98.png";